import React from "react";

const pillars = [
  { title: "REAL ESTATE", sub: "What we do.", bg: "bg-[#0d0d0d]", text: "text-white", accent: "text-[#b4936a]" },
  { title: "MARKETING", sub: "How we sell & grow.", bg: "bg-[#b4936a]", text: "text-white", accent: "text-white/80" },
  { title: "RELATIONSHIPS", sub: "Why we matter.", bg: "bg-[#1c1c1f]", text: "text-white", accent: "text-[#b4936a]" },
];

const Pillars = () => {
  return (
    <section className="bg-[#f3f1ec] py-24 md:py-32">
      <div className="max-w-[1300px] mx-auto px-6 md:px-10">
        <div className="text-center mb-14 reveal">
          <p className="text-[11px] tracking-luxe uppercase text-[#b4936a] mb-4">Our Foundation</p>
          <h2 className="font-serif-display text-4xl md:text-5xl font-light text-[#1a1a1a]">Three Pillars, One Standard</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {pillars.map((p, i) => (
            <div key={i} className="reveal-scale">
              <div className={`${p.bg} ${p.text} h-40 md:h-48 flex items-center justify-center transition-transform duration-500 hover:-translate-y-1.5 shadow-[0_20px_50px_rgba(0,0,0,0.12)]`}>
                <span className="font-sans-luxe tracking-luxe-sm text-xl md:text-2xl font-medium">{p.title}</span>
              </div>
              <p className={`text-center font-serif-display text-2xl text-[#1a1a1a] mt-6`}>{p.sub}</p>
            </div>
          ))}
        </div>

        <p className="text-center mt-16 font-serif-display italic text-2xl md:text-3xl text-[#1a1a1a] reveal">
          Built on Hustle. <span className="text-[#b4936a]">Backed by Trust.</span>
        </p>
      </div>
    </section>
  );
};

export default Pillars;
